module.exports = __webpack_public_path__ + "img/c06_unittechslingerchampion_Normal_ua.d20a4f68.webp";